document.addEventListener('DOMContentLoaded', function () {
  const input = document.querySelector('input[type="search"]');
  const resultsContainer = document.querySelector('.predictive-search-results');

  if (!input || !resultsContainer) return;

  input.addEventListener('input', function () {
    const query = input.value;

    if (query.length < 3) {
      resultsContainer.innerHTML = '';
      return;
    }

    fetch(`/search/suggest.json?q=${encodeURIComponent(query)}&resources[type]=product`)
      .then(response => response.json())
      .then(data => {
        const products = data.resources.results.products;

        resultsContainer.innerHTML = products.map(product => `
          <div class="suggestion-item">
            <a href="${product.url}">${product.title}</a>
          </div>
        `).join('');
      });
  });
});
